import RawHtml from 'stories/components/RawHtml'
import React, { PureComponent } from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'

export default class SectionInput extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
    }
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => this.props.value

  render() {
    const { touched, error, SideElement, description, label } = this.props
    const classNames = {
      'formz-text-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <label className="formz-field-and-label-holder">
          <div className="formz-section-input">
            {label && <h3>{label}</h3>}
            <RawHtml content={description} />
          </div>

          {SideElement && <SideElement />}
        </label>
      </FieldRowWrapper>
    )
  }
}
